import Config from "../../../../../../shared/src/ranj/app/config/Config";

export default class GameConfig extends Config {

    constructor() {
        super();
    }

    getSkillForBehaviour(behaviour) {
        /** @type {Object.<string, string[]>} */
        const behaviourPerSkill = this.getValue("behaviourPerSkill");
        const skill = Object.keys(behaviourPerSkill).find(key => behaviourPerSkill[key].includes(behaviour));
        return skill;
    }

    getBehaviourForKeyMomentId(episodeId, keyMomentId) {
        const behavioursPerKeyMoment = this.getValue("behavioursPerKeyMoment");
        const behaviour = behavioursPerKeyMoment[episodeId]?.[keyMomentId];
        return behaviour;
    }

    /**
     * 
     * @returns {Object.<string, {description: string, castMovieClip: string}>}
     */
    getCast() {
        return this.getValue("cast");
    }
}